import { Field } from "formik";
import { Calendar } from "../../common/imagePath";
import ReactDatetime from "react-datetime";
import moment from "moment";
import React, { useEffect, useState } from "react";
const ReportDate = (props, callback) => {
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");

  const handleStartDateChange = (e) => {
    setStartDate(e?.target.value);
    // console.log("date", momentDate);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e?.target.value);
  };

  useEffect(
    (momentDate) => {
      if (props.selectReport == 4) {
        const currentDate = new Date();
        const currentDay = currentDate.getDay(); // 0 (Sunday) to 6 (Saturday)
        const diff = currentDay === 0 ? -6 : 1 - currentDay; // Calculate the difference to the nearest Monday
        const startDate = new Date(
          currentDate.setDate(currentDate.getDate() + diff)
        );
        const endDate = new Date(currentDate.setDate(startDate.getDate() + 6));
        startDate.setDate(startDate.getDate() - 1);

        setStartDate(startDate.toISOString().split("T")[0]);
        setEndDate(endDate.toISOString().split("T")[0]);
      } else if (props.selectReport == 5) {
        const currentDate = new Date();
        const currentDay = currentDate.getDay(); // 0 (Sunday) to 6 (Saturday)
        const diff = currentDay === 0 ? -6 : 1 - currentDay; // Calculate the difference to the nearest Monday
        const startDate = new Date(
          currentDate.setDate(currentDate.getDate() + diff)
        );
        const endDate = new Date();
        startDate.setDate(startDate.getDate() - 1);

        setStartDate(startDate.toISOString().split("T")[0]);
        setEndDate(endDate.toISOString().split("T")[0]);
      } else if (props.selectReport == 6) {
        const currentDate = new Date();
        const startOfMonth = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          1
        );
        const endOfMonth = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth() + 1,
          0
        );

        startOfMonth.setDate(startOfMonth.getDate() + 1);
        endOfMonth.setDate(endOfMonth.getDate() + 1);

        setStartDate(startOfMonth.toISOString().split("T")[0]);
        setEndDate(endOfMonth.toISOString().split("T")[0]);
      } else if (props.selectReport == 7) {
        const currentDate = new Date();
        const startOfMonth = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          1
        );
        const endDate = currentDate;
        startOfMonth.setDate(startOfMonth.getDate() + 1);

        setStartDate(startOfMonth.toISOString().split("T")[0]);
        setEndDate(endDate.toISOString().split("T")[0]);
      } else if (props.selectReport == 8) {
        const currentDate = new Date();
        const quarter = Math.floor(currentDate.getMonth() / 3) + 1;
        const startOfMonth = new Date(
          currentDate.getFullYear(),
          (quarter - 1) * 3,
          1
        );
        const endOfMonth = new Date(currentDate.getFullYear(), quarter * 3, 0);

        startOfMonth.setDate(startOfMonth.getDate() + 1);
        endOfMonth.setDate(endOfMonth.getDate() + 1);

        setStartDate(startOfMonth.toISOString().split("T")[0]);
        setEndDate(endOfMonth.toISOString().split("T")[0]);
      } else if (props.selectReport == 9) {
        const currentDate = new Date();
        const quarter = Math.floor(currentDate.getMonth() / 3) + 1;
        const startOfMonth = new Date(
          currentDate.getFullYear(),
          (quarter - 1) * 3,
          1
        );
        const endDate = currentDate;

        startOfMonth.setDate(startOfMonth.getDate() + 1);

        setStartDate(startOfMonth.toISOString().split("T")[0]);
        setEndDate(endDate.toISOString().split("T")[0]);
      } else if (props.selectReport == 10) {
        const currentDate = new Date();
        console.log(currentDate.toISOString());
        const startOfYear = new Date(currentDate.getFullYear(), 0, 1);
        const endOfYear = new Date(currentDate.getFullYear(), 11, 31);

        startOfYear.setDate(startOfYear.getDate() + 1);
        endOfYear.setDate(endOfYear.getDate() + 1);

        setStartDate(startOfYear.toISOString().split("T")[0]);
        setEndDate(endOfYear.toISOString().split("T")[0]);
      } else if (props.selectReport == 11) {
        const currentDate = new Date();
        const startOfYear = new Date(currentDate.getFullYear(), 0, 1);
        startOfYear.setDate(startOfYear.getDate() + 1);

        setStartDate(startOfYear.toISOString().split("T")[0]);
        setEndDate(moment().format("YYYY-MM-DD"));
      } else if (props.selectReport == 12) {
        const today = new Date();
        const firstDayOfYear = new Date(today.getFullYear(), 0, 1); // Set the first day of the year
        const lastDayOfPreviousMonth = new Date(
          today.getFullYear(),
          today.getMonth(),
          0
        ); // Set the last day of the previous month
        firstDayOfYear.setDate(firstDayOfYear.getDate() + 1);
        lastDayOfPreviousMonth.setDate(lastDayOfPreviousMonth.getDate() + 1);

        setStartDate(firstDayOfYear.toISOString().split("T")[0]);
        setEndDate(lastDayOfPreviousMonth.toISOString().split("T")[0]);
      } else if (props.selectReport == 13) {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1); // Subtract 1 day from the current date

        setStartDate(yesterday.toISOString().split("T")[0]);
        setEndDate(yesterday.toISOString().split("T")[0]);
      } else if (props.selectReport == 14) {
        const recentDate = new Date();

        setStartDate(recentDate.toISOString().split("T")[0]);
        setEndDate(recentDate.toISOString().split("T")[0]);
      } else if (props.selectReport == 15) {
        const currentDate = new Date();
        const currentDay = currentDate.getDay(); // 0 (Sunday) to 6 (Saturday)
        const diff = currentDay === 0 ? -13 : -7 - currentDay; // Calculate the difference to the nearest Monday of the previous week
        const startDate = new Date(
          currentDate.setDate(currentDate.getDate() + diff)
        );
        const endDate = new Date(currentDate.setDate(startDate.getDate() + 6));

        setStartDate(startDate.toISOString().split("T")[0]);
        setEndDate(endDate.toISOString().split("T")[0]);
      } else if (props.selectReport == 16) {
        const currentDate = new Date();
        const currentDay = currentDate.getDay(); // 0 (Sunday) to 6 (Saturday)
        const diff = currentDay === 0 ? -13 : -7 - currentDay; // Calculate the difference to the nearest Monday of the previous week
        const startDate = new Date(
          currentDate.setDate(currentDate.getDate() + diff)
        );
        const endDate = new Date();

        setStartDate(startDate.toISOString().split("T")[0]);
        setEndDate(endDate.toISOString().split("T")[0]);
      } else if (props.selectReport == 17) {
        const currentDate = new Date();
        const firstDayOfMonth = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          1
        );
        const lastDayOfLastMonth = new Date(
          firstDayOfMonth.setDate(firstDayOfMonth.getDate() - 1)
        );
        const firstDayOfLastMonth = new Date(
          lastDayOfLastMonth.getFullYear(),
          lastDayOfLastMonth.getMonth(),
          1
        );

        firstDayOfLastMonth.setDate(firstDayOfLastMonth.getDate() + 1);
        lastDayOfLastMonth.setDate(lastDayOfLastMonth.getDate() + 1);

        setStartDate(firstDayOfLastMonth.toISOString().split("T")[0]);
        setEndDate(lastDayOfLastMonth.toISOString().split("T")[0]);
      } else if (props.selectReport == 18) {
        const currentDate = new Date();
        const firstDayOfMonth = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          1
        );
        const lastDayOfLastMonth = new Date(
          firstDayOfMonth.setDate(firstDayOfMonth.getDate() - 1)
        );
        const firstDayOfLastMonth = new Date(
          lastDayOfLastMonth.getFullYear(),
          lastDayOfLastMonth.getMonth(),
          1
        );
        const today = new Date();
        firstDayOfLastMonth.setDate(firstDayOfLastMonth.getDate() + 1);

        setStartDate(firstDayOfLastMonth.toISOString().split("T")[0]);
        setEndDate(today.toISOString().split("T")[0]);
      } else if (props.selectReport == 19) {
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth();
        const currentYear = currentDate.getFullYear();

        let previousQuarterStartMonth;
        let previousQuarterEndMonth;

        if (currentMonth >= 0 && currentMonth <= 2) {
          previousQuarterStartMonth = 9; // October
          previousQuarterEndMonth = 11; // December
        } else if (currentMonth >= 3 && currentMonth <= 5) {
          previousQuarterStartMonth = 0; // January
          previousQuarterEndMonth = 2; // March
        } else if (currentMonth >= 6 && currentMonth <= 8) {
          previousQuarterStartMonth = 3; // April
          previousQuarterEndMonth = 5; // June
        } else {
          previousQuarterStartMonth = 6; // July
          previousQuarterEndMonth = 8; // September
        }

        const previousQuarterStartDate = new Date(
          currentYear,
          previousQuarterStartMonth,
          1
        );
        const previousQuarterEndDate = new Date(
          currentYear,
          previousQuarterEndMonth + 1,
          0
        );

        previousQuarterStartDate.setDate(
          previousQuarterStartDate.getDate() + 1
        );
        previousQuarterEndDate.setDate(previousQuarterEndDate.getDate() + 1);

        setStartDate(previousQuarterStartDate.toISOString().split("T")[0]);
        setEndDate(previousQuarterEndDate.toISOString().split("T")[0]);
      } else if (props.selectReport == 20) {
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth();
        const currentYear = currentDate.getFullYear();

        let previousQuarterStartMonth;
        let previousQuarterEndMonth;

        if (currentMonth >= 0 && currentMonth <= 2) {
          previousQuarterStartMonth = 9; // October
          previousQuarterEndMonth = 11; // December
        } else if (currentMonth >= 3 && currentMonth <= 5) {
          previousQuarterStartMonth = 0; // January
          previousQuarterEndMonth = 2; // March
        } else if (currentMonth >= 6 && currentMonth <= 8) {
          previousQuarterStartMonth = 3; // April
          previousQuarterEndMonth = 5; // June
        } else {
          previousQuarterStartMonth = 6; // July
          previousQuarterEndMonth = 8; // September
        }

        const previousQuarterStartDate = new Date(
          currentYear,
          previousQuarterStartMonth,
          1
        );
        // const currentDate = new Date(); // Today's date
        previousQuarterStartDate.setDate(
          previousQuarterStartDate.getDate() + 1
        );

        setStartDate(previousQuarterStartDate.toISOString().split("T")[0]);
        setEndDate(currentDate.toISOString().split("T")[0]);
      } else if (props.selectReport == 21) {
        const currentDate = new Date();
        const previousYear = currentDate.getFullYear() - 1;
        const startDate = new Date(previousYear, 0, 1);
        const endDate = new Date(previousYear, 11, 31);
        startDate.setDate(startDate.getDate() + 1);
        endDate.setDate(endDate.getDate() + 1);

        setStartDate(startDate.toISOString().split("T")[0]);
        setEndDate(endDate.toISOString().split("T")[0]);
      } else if (props.selectReport == 22) {
        const currentDate = new Date();
        const previousYear = currentDate.getFullYear() - 1;
        const startDate = new Date(previousYear, 0, 1);
        const endDate = new Date();
        startDate.setDate(startDate.getDate() + 1);

        setStartDate(startDate.toISOString().split("T")[0]);
        setEndDate(endDate.toISOString().split("T")[0]);
      } else if (props.selectReport == 23) {
        const currentDate = new Date();
        const startDate = new Date(
          currentDate.setDate(currentDate.getDate() - 30)
        );
        const endDate = new Date();

        setStartDate(startDate.toISOString().split("T")[0]);
        setEndDate(endDate.toISOString().split("T")[0]);
      } else if (props.selectReport == 24) {
        const currentDate = new Date();
        const startDate = new Date(
          currentDate.setDate(currentDate.getDate() - 60)
        );
        const endDate = new Date();
        startDate.setDate(startDate.getDate() - 1);

        setStartDate(startDate.toISOString().split("T")[0]);
        setEndDate(endDate.toISOString().split("T")[0]);
      } else if (props.selectReport == 25) {
        const currentDate = new Date();
        const startDate = new Date(
          currentDate.setDate(currentDate.getDate() - 90)
        );
        const endDate = new Date();
        startDate.setDate(startDate.getDate() + 1);
        setStartDate(startDate.toISOString().split("T")[0]);
        setEndDate(endDate.toISOString().split("T")[0]);
      } else if (props.selectReport == 26) {
        const currentDate = new Date();
        const startDate = new Date(
          currentDate.getFullYear() - 1,
          currentDate.getMonth(),
          currentDate.getDate()
        );
        const endDate = new Date();
        startDate.setDate(startDate.getDate() + 1);

        setStartDate(startDate.toISOString().split("T")[0]);
        setEndDate(endDate.toISOString().split("T")[0]);
      } else if (props.selectReport == 27) {
        const currentDate = new Date();
        const currentDay = currentDate.getDay(); // 0 (Sunday) to 6 (Saturday)
        const diff = currentDay === 0 ? 1 : 8 - currentDay; // Calculate the difference to the nearest Monday of next week
        const startDate = new Date(
          currentDate.setDate(currentDate.getDate() + diff)
        );
        const endDate = new Date(currentDate.setDate(startDate.getDate() + 6));

        setStartDate(startDate.toISOString().split("T")[0]);
        setEndDate(endDate.toISOString().split("T")[0]);
      } else if (props.selectReport == 28) {
        const currentDate = new Date();
        const nextStartDate = new Date(
          currentDate.getTime() + 7 * 24 * 60 * 60 * 1000
        ); // Add 1 week to the current date
        const nextEndDate = new Date(
          nextStartDate.getTime() + 27 * 24 * 60 * 60 * 1000
        ); // Add 4 weeks to the start date
        nextStartDate.setDate(nextStartDate.getDate() - 2);
        nextEndDate.setDate(nextEndDate.getDate() - 2);

        setStartDate(nextStartDate.toISOString().split("T")[0]);
        setEndDate(nextEndDate.toISOString().split("T")[0]);
      } else if (props.selectReport == 29) {
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth();
        const currentYear = currentDate.getFullYear();
        const nextMonth = currentMonth === 11 ? 0 : currentMonth + 1; // Handle year transition
        const nextYear = currentMonth === 11 ? currentYear + 1 : currentYear;
        const startDate = new Date(nextYear, nextMonth, 1); // First day of next month
        const endDate = new Date(nextYear, nextMonth + 1, 0); // Last day of next month
        startDate.setDate(startDate.getDate() + 1);
        endDate.setDate(endDate.getDate() + 1);

        setStartDate(startDate.toISOString().split("T")[0]);
        setEndDate(endDate.toISOString().split("T")[0]);
      } else if (props.selectReport == 30) {
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth();
        const currentYear = currentDate.getFullYear();

        // Calculate the next quarter
        const nextQuarter = Math.floor((currentMonth + 2) / 3) + 1;
        const nextQuarterStartDate = new Date(
          currentYear,
          (nextQuarter - 1) * 3,
          1
        );
        const nextQuarterEndDate = new Date(currentYear, nextQuarter * 3, 0);

        nextQuarterStartDate.setDate(nextQuarterStartDate.getDate() + 1);
        nextQuarterEndDate.setDate(nextQuarterEndDate.getDate() + 1);

        setStartDate(nextQuarterStartDate.toISOString().split("T")[0]);
        setEndDate(nextQuarterEndDate.toISOString().split("T")[0]);
      } else if (props.selectReport == 31) {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();

        const nextYearStartDate = new Date(currentYear + 1, 0, 1);
        const nextYearEndDate = new Date(currentYear + 1, 11, 31);

        nextYearStartDate.setDate(nextYearStartDate.getDate() + 1);
        nextYearEndDate.setDate(nextYearEndDate.getDate() + 1);

        setStartDate(nextYearStartDate.toISOString().split("T")[0]);
        setEndDate(nextYearEndDate.toISOString().split("T")[0]);
      } else if (props.selectReport == 3) {
        setStartDate(moment(momentDate).format("YYYY-MM-DD"));
        setEndDate(moment(momentDate).format("YYYY-MM-DD"));
      } else {
        setStartDate("");
        setEndDate("");
        // setStartDate(moment(momentDate).format("YYYY-MM-DD"));
        // setEndDate(moment(momentDate).format("YYYY-MM-DD"));
        // props.callback(startdate, enddate);
      }
      //
    },
    [props.selectReport]
  );

  useEffect(() => {
    props.callback(startdate, enddate);
  }, [startdate, enddate]);

  return (
    <>
      {props.showhidecomponent && (
        <div className="row mt-1">
          <div className="col-sm-6">
            <div className="row">
              <label className="col-form-label col-md-4 form-label">
                Start Date
              </label>
              <div className="col-lg-8">
                <input
                  type="date"
                  value={startdate}
                  className="form-control"
                  id="Startdate"
                  name="Startdate"
                  onChange={(e) => handleStartDateChange(e)}
                />
              </div>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="row">
              <label className="col-form-label col-md-4 form-label">
                End Date
              </label>
              <div className="col-lg-8">
                <input
                  type="date"
                  value={enddate}
                  className="form-control"
                  id="enddate"
                  name="enddate"
                  onChange={(e) => handleEndDateChange(e)}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ReportDate;
